const tw = {
    ChatLayout: {
        nav_chat: "談話",
        resource: "談話資料管理",
        upload: "談話資料登録",
        history: "履歷",
        setting: "設定",
        connection: "外部連接",
        delete: "刪除",
        clear_messages: "清空",
        back: "返回",
    },
    NavBar: {
        chats: "談話一覽",
        admin: "用戶管理",
        settings: "設定",
        logout: "登出",
        saleslists: "列表一覽",
        salestemplate: "信件模板",
        usage: "費用明細",
        product_writing: "VectorFlux for Writing",
        product_sales: "VectorFlux for Sales",
        product_chat: "VectorFlux",
    },
    EditGroupView: {
        h1: "用戶組編輯：",
        group_name: "用戶組名：",
        created_at: "創建日期和時間：",
        modified_at: "最終更新日期：",
        user_group_h4: "用戶組的用戶添加",
        username: "用戶名",
        fullname: "姓名",
        roles: "權限",
        user_group_h4_2: "可用的談話機器人添加",
        chat_title: "談話機器人名",
        submit: "更新",
        handleBack: "返回",
        edit_group_err: "用戶組信息變更失敗！",
    },
    EditUserView: {
        h1: "用戶編輯：",
        username: "用戶ID：",
        mail_address: "電子郵件地址：",
        full_name: "姓名：",
        password: "密碼：",
        show: "表示",
        not_show: "非表示",
        roles: "權限：",
        groups: "用戶組：",
        created_at: "用戶登錄日時：",
        modified_at: "最終更新日期：",
        submit: "更新",
        handleBack: "返回",
        change_password: "密碼変更",
        password_format_err: "密碼長度必須至少為 8 個字符，並包含大小寫字母、數字和特殊字符。",
        role_error: "請選擇用戶權限",
        group_error: "請選擇用戶所屬的用戶組",
    },
    NewGroupView: {
        h1: "新建用戶組",
        group_name: "用戶組名：",
        user_group_h4: "用戶組的用戶添加",
        username: "用戶名",
        fullname: "姓名",
        roles: "權限",
        user_group_h4_2: "用戶組談話機器人添加",
        chat_title: "談話機器人名",
        submit: "保存",
        handleBack: "返回",
        new_group_err: "新用戶組注冊失敗！\n請確認該用戶組是否已經被注冊。",
        registered_group: "※已注冊的用戶組，請更改用戶組名。",
    },
    NewUserView: {
        h1: "新建用戶",
        username: "用戶ID：",
        full_name: "全名：",
        mail_address: "電子郵件地址：",
        password: "密碼：",
        show: "表示",
        not_show: "非表示",
        roles: "權限：",
        groups: "用戶組：",
        submit: "注冊",
        handleBack: "返回",
        password_format_err: "密碼長度必須至少為 8 個字符，並包含大小寫字母、數字和特殊字符。",
        role_error: "請選擇用戶權限",
        group_error: "請選擇用戶所屬的用戶組",
    },
    UserListView: {
        user_h4: "用戶一覽",
        add_User: "新建用戶",
        username: "用戶名",
        fullname: "姓名",
        roles: "權限",
        groups: "用戶組",
        modified_at: "最終更新日期",
        created_at: "登錄日期",
        operation: "操作",
        edit: "編輯",
        delete: "刪除",
        group_h4: "用戶組一覽",
        add_group: "新建用戶組",
        group_name: "用戶組名",
        update_date_time: "更新日期",
        ip_h4: "IP白名單",
        ip_list: "IP",
        add_ip: "IP追加",
        modal_title: "警告",
        warning_msg_1: "刪除用戶組請注意以下事項:",
        warning_msg_2: "1.屬於該用戶組的用戶和談話將會取消與該用戶組關聯。",
        warning_msg_3: "2.如果某個談話只關聯了該用戶組，則只有擁有管理員權限的用戶才能看到或者編輯此談話",
        warning_msg_4: "要刪除嗎？",
        // user_warning_msg_1: "本当にユーザーを削除しますか？",
        cancel: "取消",
        del_err: "用戶組刪除失敗！\n該用戶組不存在或已經刪除。\n請刷新畫面再試一次。",
        ip_del_err: "IP刪除失敗！",
        ip_edit_err: "請輸入正確的IP地址",
        ip_save_err: "IP保存失敗！",
        ip_edit_err2: "IP已經存在！",
        save: "保存",
    },
    AdminErrorView: {
        h1: "無訪問權限",
        error_message: "請向您的系統管理員請求訪問權限或切換到具有訪問權限的帳戶",
        back_button: "返回",
    },
    ChatResourceUploadView: {
        h1: "談話資料登録",
        resource_type: "談話資料類型",
        file: "文件",
        choose_file: "選擇文件",
        file_name: "文件名",
        tags: "標簽",
        tags_format: "標簽1,標簽2,標簽3",
        upload: "上傳",
        page_title: "頁面標題",
        page_name: "頁名",
        uploadWebResource: "登録",
        no_files_selected: "未選擇任何文本。",
        update_ok_msg: "上傳成功。",
        update_err_msg: "上傳失敗。",
        response_ok_msg: "數據錄入成功。",
        response_err_msg: "數據錄入失敗。",
        not_pdf: "上傳的文件必須爲PDF文件",
    },
    ChatResourceView: {
        h4: "已登錄談話資料一覽",
        keyword: "關鍵詞",
        tags: "標簽",
        total_number_of_characters: "文字數合計：",
        resource_count: "談話資料数：",
        filter: "過濾",
        resource_name: "談話資料名",
        file_type: "文件形式",
        created_at: "登錄日期",
        status: "狀態",
        operation: "操作",
        edit: "編輯",
        delete: "刪除",
        status_zero: "處理等待",
        status_one: "讀取中",
        status_two: "完成",
        status_three: "錯誤",
    },
    ChatScreenView: {
        input_msg: "請輸入信息",
        error_messages: "發生了錯誤，請稍後再試",
        close: "關閉",
        template_message: "範本問題",
        link: "外部鏈接",
        new_talk: "+ 新談話",
        his_talk: "談話記錄",
        memory_flag: "對話記憶",
    },
    ChatSettingView: {
        h4: "談話機器人設定",
        chat_namespace: "談話ID：",
        chat_title: "談話機器人名：",
        system_prompt: "系統提示符：",
        temperature: "回答的靈活性：",
        model: "模型",
        template_message: "範本問題：",
        add: "追加",
        del: "刪除",
        title: "標題",
        msg: "提問内容",
        must: "必填",
        group: "可查看的用戶組",
        memory: "記憶談話",
        update: "更新",
        handle_return: "返回",
        alert_max_10: "提問内容最多只能記錄10條",
        alert_not_edit: "存在沒有記入的提問内容，請記入提問内容。",
        chat_setting_err_msg: "談話機器人設定失敗。",
        chat_setting_ok_msg: "談話機器人設定成功。",
    },
    NewChatView: {
        h3: "談話機器人定制",
        chat_title: "談話機器人名：",
        groups: "擁有瀏覽權限的用戶組：",
        system_prompt: "系統提示符：",
        temperature: "回答的靈活性：",
        group_err: "請選擇可查看的用戶組",
        memory: "記憶談話",
        handleCreate: "注冊",
        handleReturn: "返回",
    },
    EditPasswordView: {
        h1: "密碼変更",
        old_password: "原密碼：",
        incorrect_password: "密碼不正確！",
        new_password: "新密碼：",
        new_password_confirmation: "新密碼（確認）：",
        passwords_do_not_match: "密碼不一致！",
        password_format_err: "密碼長度必須至少為 8 個字符，並包含大小寫字母、數字和特殊字符。",
        submit: "変更",
        handleBack: "返回",
    },
    SettingsView: {
        h4: "個人資料",
        username: "用戶ID：",
        full_name: "用戶顯示名：",
        mail_address: "電子郵件地址：",
        not_mail_address: "請輸入正確的郵件地址",
        otp_on: "開啓登錄時的郵件2次認證",
        otp_warning: "**注意：如要開啓登錄時的郵件2次認證，需輸入郵件地址",
        modal_title: "郵件地址認證",
        modal_body: "認證碼：",
        otp_msg: "請在下方輸入驗證碼",
        invalid_otp_code_1: "驗證碼不正確！",
        invalid_otp_code_2: "如要開啓登錄時的郵件2次認證，請輸入您的郵件地址",
        setting_ok: "設定OK!",
        send_btn: "驗證",
        close_btn: "取消",
        change_password: "密碼変更",
        update: "更新",
        handle_return: "返回",
        user_plan: "費用賬單查詢",
    },
    UserPlanView: {
        plan_detail: "月間使用狀況",
        element: "項目",
        used: "使用量",
        limit: "使用上限",
        fetch_error: "取得 AI 聊天用量失敗，請稍後再試。",
        message_count_3: "回答件數(GPT-3.5)",
        message_count_4: "回答件數(GPT-4)",
        resource_detail: "談話資料存儲明細",
        resource_characters_count: "談話資料文字數",
        user_count: "用戶數",
        chat_count: "談話機器人數",
        handle_return: "返回",
    },
    ChatListView: {
        h4: "談話機器人一覽",
        serach_keyword: "關鍵詞：",
        chat_count: "談話機器人数：",
        handle_create: "新建",
        handle_filter: "過濾",
        chat_title: "談話機器人名",
        author: "建立日期",
        operation: "操作",
        delete: "刪除",
        modal_title: "警告",
        warning_msg_1: "請確認",
        warning_msg_2: "即將刪除談話！",
        cancel: "取消",
    },
    ChatView: {
        enter_message: "請輸入信息！",
        file_name: "文件名",
        tags: "標簽",
        source: "【參照來源】：",
    },
    ChatEditResourceView: {
        h4: "編輯資源",
        resource_name: "談話資料名：",
        file_type: "文件形式：",
        tags: "標簽",
        description: "備考：",
        status: "狀態：",
        created_at: "登錄日期：",
        modified_at: "更新日期：",
        resource_text: "文本：",
        submit: "更新",
        backToResources: "返回",
        error_messages: "發生了錯誤",
        close: "關閉",
    },
    ChatConnectionView: {
        h4: "外部系統連接",
        messenger: "Messenger",
        messenger_service_name: "連接目標服務：",
        messenger_active_status: "有效狀態：",
        messenger_callback_url: "回呼URL：",
        messenger_verify_token: "驗證令牌：",
        messenger_facebook_page_id: "Facebook頁面ID：",
        messenger_access_token: "訪問令牌：",
        submit: "更新",
        hide_token: "隱藏",
        show_token: "顯示",
        error_messages: "發生了錯誤",
        error_messages_fbduplicate: "無法更新，因為 Facebook 專頁 ID 重複",
    },
    LoginView: {
        username: "用戶名：",
        invalid_username_or_password: "用戶名或者密碼不正確！",
        modal_title: "郵件二次認證",
        modal_body: "認證碼：",
        otp_msg: "請輸入郵件中的驗證碼",
        invalid_otp_code_1: "認證碼錯誤！",
        invalid_otp_code_2: "超過最大驗證回數！請重新登錄。",
        send_btn: "驗證",
        close_btn: "取消",
        password: "密碼：",
        submit: "登錄",
        session_expired_hint: "因閒置時間已超時，登入狀態已失效。請重新登入。",
        ip_modal_title: "IP白名單錯誤",
        ip_err_1: "客戶端的IP地址不在IP白名單之内。",
        ip_err_2: "請聯係系統管理員。",
    },
    RegisterView: {
        h4: "已登錄談話資料一覽",
        search_keyword: "關鍵詞",
        tags: "標簽",
        total_number_of_characters: "文字數合計：",
        resource_count: "談話資料数：",
        filter: "過濾",
        resource_name: "談話資料名",
        file_type: "文件形式",
        created_at: "登錄日期",
        status: "狀態",
        operation: "操作",
        edit: "編輯",
        delete: "刪除",
    },
    UploadFileView: {
        upload_title: "談話資料登録",
        resource_type: "談話資料類型",
        file: "文件",
        file_upload: "選擇檔案",
        file_name: "文件名",
        tags: "標簽",
        tags_format: "標簽1,標簽2,標簽3",
        uploadFile: "上傳",
        document_title: "頁面標題",
        uploadWebResource: "登録",
    },
    TagsInput: {
        admin_del_msg: "無法刪除管理員使用者權限，因為管理員可以管理所有聊天。",
    },

    UploadServiceView: {
        // upload_title: "談話資料登録",
        resource_type: "談話資料類型",
        file: "文件",
        file_upload: "選擇檔案",
        // file_name: "文件名",
        // tags: "標簽",
        // tags_format: "標簽1,標簽2,標簽3",
        uploadFile: "上傳",
        // document_title: "頁面標題",
        uploadWebResource: "登録",
    },

    SalesListsView: {
        h4: "列表一覽",
        search_keyword: "關鍵字:",
        list_count: "列表數量:",
        sort_by: "排序依據：",
        sort_created_at: "建立時間",
        sort_modified_at: "更新時間",
        sort_order: "排序方式：",
        sort_desc: "新到舊",
        sort_asc: "舊到新",
        handle_create: "新增",
        list_title: "列表標題",
        author: "建立時間",
        edit: "編輯",
        delete: "刪除",

        delete_confirm: "確定要刪除選中的 Sales list ?",
        OK: "確定",
        cancel: "取消"
    },

    SalesListsDetailsLayout: {
        h1: "清單標題 1",
        company_list: "公司列表",
        csv_import: "CSV導入",
        company_setting: "清單設定"
    },

    SalesListsDetailsView: {
        h4: "公司列表",
        search_keyword: "關鍵字:",
        handle_filter: "過慮",
        target_flag: "開始生成",
        target: "生成對象",
        regeneration: "再次生成",
        company_information: "獲取公司資訊",
        text_generate: "文章生成",
        text_confirm: "内容確認",

        send_mail: "發電子郵件",
        data_count: "數據總件數：",

        select_all: "全選/取消全選",
        handleCreate: "+ 新增公司",
        handle_send: "一次發送",
        refresh: "更新列表",
        handle_refresh: "刷新內容",

        selected: "選擇",
        company_name: "公司名稱",
        company_url: "URL",

        crawl_status: "公司資訊取得",
        generate_status: "文章生成",
        check_status: "文章確認",
        send_status: "發送電子郵件",
        last_sent_at: "最後發送時間",

        process_pending: "等待處理",
        processing: "處理中",
        finish: "完成",
        process_fail: "處理失敗",

        generate_pending: "等待生成",
        generating: "生成中",
        generate_fail: "生成失敗",

        uncheck: "未確認",
        checked: "已確認",

        send_none: "未發信",
        send_pending: "等待發送",
        send_processing: "發送中",
        send_finish: "已發送",
        send_fail: "發送失敗",
        send_delivered: "發送成功",
        send_open: "郵件已閱",
        send_click: "鏈接已點擊",

        all: "全部",
        before_generation: "產生前",
        generated_unconfirmed: "已產生，未確認",
        waiting_send: "寄送前",
        completed: "寄送完成",
        failed: "失敗",
        operation: "操作",
        edit: "編輯",
        delete: "刪除",

        bulk_delete: "一括刪除",
        bulk_delete_confirm_title: "一括刪除",
        bulk_delete_confirm_message: "選擇的會公司將被刪除，確定要繼續嗎？",

        delete_confirm: "確定要刪除嗎?",
        OK: "確定",
        cancel: "取消",
        send_mail_modal_title: "提示",
        send_mail_modal_text: "郵件已發送",
        confirm_and_send: "確認済みにして送信",

        model_title: "編輯/確認公司",
        model_company_name: "公司名稱：",
        model_person_name: "負責人：",
        model_company_url: "URL:",
        model_email: "電子郵件地址：：",
        model_company_detail: "公司概況：",
        model_mail_text: "文章：",
        model_check_status: "確認：",
        model_update: "更新",
    },

    NewSalesListsDetailsView: {
        h3: "編輯/確認公司",

        company_name: "公司名稱：",
        company_url: "URL:",
        email: "電子郵件地址：",
        company_detail: "概要：",
        mail_text: "文章：",
        person_name: "負責人：",

        return: "返回",
        update: "新增",
    },

    NewSalesListsView: {
        h3: "新增銷售列表",

        resource_type: "談話資料類型",
        file: "文件",

        title_base: "基本資料",
        title_service: "服務資訊",
        title_template: "模板選擇",

        list_name: "列表一覽",

        send_mode: "傳輸模式",
        send_mode_auto: "自動判定",
        send_mode_mail: "僅限電子郵件",
        send_mode_form: "僅提交表單",

        sender_company_name: "發送公司",
        sender_company_url: "發送公司 URL",
        sender_name: "發送者",
        sender_mail_address: "發送者 email",

        furigana: "【送信元】 担当者名(フリガナ)",
        gender: "【送信元】 性別",
        pref: "【送信元】 都道府県",
        city: "【送信元】 市区町村",
        street_number: "【送信元】 番地",
        building_name: "【送信元】 建物名",
        postal_code: "【送信元】 郵便番号",
        tel: "【送信元】 電話番号",

        mail_title: "郵件標題",
        to_name: "接收者",
        bcc: "密件副本",
        to_name_default: "負責人",
        file_upload: "*選擇郵件添附檔案：",
        must_pdf: "*僅可上傳PDF檔案",
        not_pdf: "上傳的檔案必須爲PDF",

        service_name: "服務名稱",
        service_detail_summary: "服務詳情",
        multi_service_flag: "複數的商品/服務自動提案功能",
        service_detail_template_name: "服務詳情模板",
        service_detail_template_apply: "套用",
        service_detail_template_save: "儲存為模板",

        template_name: "模板名稱",

        additional_prompt: "提示：",
        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 已經儲存清單，但由於缺少必填欄位，無法送出。請填寫以下必填欄位。",

        return: "返回",
        next: "下一步",
        finished: "完成",

        import: "透過文件/URL 輸入"
    },

    EditSalesListsView: {
        h3: "編輯銷售列表",

        resource_type: "談話資料類型",
        file: "附件檔案",

        title_base: "基本資料",
        title_service: "服務資訊",
        title_template: "模板選擇",

        list_name: "銷售列表",
        send_mode: "發送模式",
        send_mode_auto: "自動判定",
        send_mode_mail: "郵件發送",
        send_mode_form: "表單發送",

        sender_company_name: "發送公司",
        sender_company_url: "發送公司 URL",
        sender_name: "發送者",
        sender_mail_address: "發送者 email",
        furigana:      "【發送者】 片假名：",
        gender:        "【發送者】 性別：",
        pref:          "【發送者】 都道府縣：",
        city:          "【發送者】 市區鎮村：",
        street_number: "【發送者】 門牌號碼：",
        building_name: "【發送者】 建物名稱：",
        postal_code:   "【發送者】 郵遞區號：",
        // tel: "【送信元】 電話番号",
        mail_title: "郵件標題",
        to_name: "接收者",
        bcc: "密件副本",
        to_name_default: "負責人",

        service_name: "服務名稱",
        service_detail_summary: "服務詳情",
        multi_service_flag: "複數的商品/服務自動提案功能",
        service_detail_template_name: "服務詳情模板",
        service_detail_template_apply: "套用",
        service_detail_template_save: "儲存為模板",

        template_name: "模板名稱",

        additional_prompt: "提示：",
        prompt_str: "【什麼是提示？】<br>" +
            "在此專案中，您可以新增在產生電子郵件文字時要傳達給產生 AI 的限制。<br>" +
            "【具體範例】<br>" +
            "指定字元數``請在600個字元以內建立。<br>" +
            "插入會議預訂連結``請務必在文字後半部包含以下項目。<br>" +
            "「如果您有興趣，請使用下面的連結進行預訂。<br>" +
            "◆ 會議預約連結 https://～～～ *預約約1分鐘內完成。",
        multi_service_help: "啟用此功能後，系統會根據「想推銷的商品／服務概要」中所填寫的內容，自動篩選並推薦最適合給潛在客戶的商品／服務。",

        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 已經儲存清單，但由於缺少必填欄位，無法送出。請填寫以下必填欄位",
        isnot_valid_msg: "尚有未填寫的必填欄位。若要啟用產生與送出功能，請先完成並更新所有必填欄位。",

        return: "返回",
        next: "下一步",
        update: "更新",

        import: "透過文件/URL 輸入",
        delete_title: "刪除",
        delete_confirm: "是否刪除附件檔案？",
        OK: "刪除",
        cancel: "取消"
    },

    SalesListsImportView: {
        h3: "CSV 導入",
        csv_drag: "拖放 CSV 檔案",
        input_directly: "或不使用CSV直接輸入",

        table_name: "欄位對應",

        field_name: "欄位名稱",
        csv_field: "CSV對應欄位",
        sample_value: "取樣值",

        company_name: "公司名稱",
        company_url: "公司網址",
        company_detail: "公司描述",
        person_name: "負責人",
        email: "郵箱地址",
        tel: "電話",
        contact_url: "連繫網址",
        mail_text: "發送內容",

        upload_file: "導入",
    },

    sales_templates: {
        h4: "電子郵件文字範本列表",
        search_keyword: "關鍵字:",
        list_count: "列表數量:",
        filter: "過濾",
        handle_create: "新增",
        list_title: "模板標題",
        author: "建立時間",
        edit: "編輯",
        delete: "刪除",

        delete_confirm: "確定要刪除選中的 Sales template ?",
        OK: "確定",
        cancel: "取消"
    },

    sales_templates_new: {
        h3: "創建新模板",

        template_name: "模板名稱",
        template_text: "模板內容",

        new: "新增",
        cancel: "取消",

        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 是必填欄位, 請輸入。",
    },

    service_detail_templates_new: {
        h3: "建立服務詳情模板",
        template_name: "模板名稱",
        service_name: "服務名稱",
        service_detail_summary: "服務詳情",
        new: "新增",
        cancel: "取消",
        check_modal_msg: " 是必填欄位, 請輸入。",
    },

    sales_templates_edit: {
        h3: "編輯模板",

        template_name: "模板名稱",
        template_text: "模板內容",

        update: "更新",
        cancel: "取消",

        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 是必填欄位, 請輸入。",
    },

    SalesUsageDetailsView: {
        usage_detail: "使用明細",
        item: "項目",
        total_number: "合計件數",
        number_of_success: "成功數",
        number_of_failures: "失敗數",
        fetch_error: "取得帳單資料失敗，請稍後再試。",
        number_of_articles_generated: "文章生成數：",
        number_of_emails_sent: "郵件發送數：",
        number_of_form_sent: "表單發送數：",
        amount_detail: "費用明細",
        total_amount: "合計金額：",
        detail: "明細：",
        quantity: "數量",
        unit_price: "單價",
        amount: "金額",
        base_amount: "基礎月費",
        base_amount1: "基礎月費(最大",
        base_amount2: "件)",
        append_amount: "追加生成費用",
        ack_button: "返回",
        back_button: "返回"
    },

    OptionsErrorView: {
        h1              : "無訪問權限",
        error_message   : "沒有For Sales的訪問許可權。",
        back_button     : "返回"
    },

    company_db: {
        h3: "公司搜尋",

        categories: "行業",
        prefecture: "都道府縣",
        capital_stock: "資本額",
        amount_sales: "營業額",
        established_year_month_min: "創立年月日",
        employee_number: "員工人數",
        offices_number: "辦公室數量",
        stores_number: "門店數量",
        stock_market: "上市別",

        stock_market_1: "東京證交所總理",
        stock_market_2: "東證標準",
        stock_market_3: "東京證交所成長",

        stock_market_4: "名古屋证券交易所-Premier",
        stock_market_5: "名古屋证券交易所-主板",
        stock_market_6: "名古屋证券交易所-Next",

        stock_market_7: "札幌证券交易所-主板",
        stock_market_8: "札幌证券交易所-成长",
        stock_market_9: "福冈证券交易所-主板",

        stock_market_10: "未上市",

        filter_result: "縮小範圍",
        import_result: "導入搜尋結果",

        f_title_0: "搜尋結果",
        f_title_1: "個樣本中的前",
        f_title_2: "個樣本",

        company_name: "公司名稱",
        company_url: "公司網址",
        representative_name: "法人代表",

        categories_title: "選擇產業",

        import_title: "導入搜尋結果",
        import_list: "導入目的地列表",
        import_no: "導入數量",
        import_begin: "開始導入",

        alert_msg: "導入數量必須小於",
        message: "訊息",
        inserted: "匯入成功",
        insert_fail: "匯入失敗"
    },

    NavBarForWriting: {
        post_management_list: "投稿管理列表",
        connect_to: "投稿目標",
        usage: "使用狀況",
        setting: "設定",
        logout: "登出",
    },

    // fw00_check_point_limit.vue
    CheckOverPoints: {
        try_is_over: "免費試用已結束, 請註冊標準計劃。",
        register_standard_plan: "註冊標準計劃",
    },

    // fw01_signin.vue
    SignIn: {
        register: "帳戶註冊",
        free_trial: "免費試用",
        email: "電子郵件",
        password: "密碼",
        company_name: "公司名",
        full_name: "姓名",
        invalid_username_or_password: "用戶名或者密碼不正確！",
        username_already_exists: "此電子郵件已經被註冊過了。",
        create_data_error: "資料建立失敗，請稍後再試。",
        login: "帳戶註冊",
        provider: "提供事業者",
        commercial_transaction: "特定商取引法に基づく表記",
        privacy_policy: "隱私權政策",
        already_have_account: "已經有帳戶了嗎？",
        go_to_login: "前往登入頁面",
    },

    // fw02_login.vue
    LogIn: {
        email: "電子郵件",
        password: "密碼",
        invalid_username_or_password: "用戶名或者密碼不正確！",
        login: "登入",

        send_link: "發送魔法連結電子郵件",
        forget_password: "忘記密碼了嗎？",
        to_sign_up: "沒有帳戶？註冊一個",
        no_account_yet: "還沒有帳戶嗎？",
        go_to_signin: "前往帳戶註冊頁面",
        session_expired_hint: "因閒置時間已超時，登入狀態已失效。請重新登入。",
        provider: "提供事業者",
        commercial_transaction: "特定商取引法に基づく表記",
        privacy_policy: "隱私權政策",
    },

    // fw03_ArticleLists.vue
    ArticleLists: {
        h4: "投稿管理清單列表",
        search_keyword: "關鍵詞",
        filter: "過濾",
        count: "數量:",
        create: "新建",
        list_title: "列表標題",
        author: "建立日期",
        delete: "刪除",
        delete_prompt: "警告：確定要刪除清單 name 嗎？",
        OK: "確定",
        cancel: "取消",
    },

    // fw04_ArticleLists_New.vue
    ArticleLists_New: {
        h3: "建立新列表",
        list_name: "列表名稱",
        create: "創建",
        return: "返回",

        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 是必填欄位, 請輸入。",
    },

    // fw23_setting.vue.vue
    ArticleLists_Update: {
        h4: "清單設定",
        list_name: "列表名稱",
        update: "更新",
        return: "返回",

        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 是必填欄位, 請輸入。",
    },

    // fw23_setting.vue - GA Settings
    setting: {
        ga_integration: "連動設定",
        ga_overview: "連動 Google Analytics 後，可分析自家媒體的熱門文章，自動生成新文章的匹配度判定提示詞。請依照以下3個步驟進行設定。",

        // Step 1: Property ID
        ga_help_step1_title: "STEP 1: 確認 GA Property ID",
        ga_help_step1_1: '登入 <a href="https://analytics.google.com/" target="_blank">Google Analytics</a>。',
        ga_help_step1_2: '點擊左下角的<b>管理</b>（齒輪圖示）。',
        ga_help_step1_3: '開啟「資源設定」>「資源詳細資料」。',
        ga_help_step1_4: '複製「資源 ID」中顯示的<b>數字（例：123456789）</b>，貼到下方的表單中。',

        // Step 2: Service Account
        ga_help_step2_title: "STEP 2: 建立服務帳號金鑰",
        ga_help_step2_1: '登入 <a href="https://console.cloud.google.com/" target="_blank">Google Cloud Console</a>。',
        ga_help_step2_2: '在上方搜尋欄搜尋 <b>「Google Analytics Data API」</b>，並<b>啟用</b>該 API。',
        ga_help_step2_3: '從左側選單開啟 <b>「IAM 與管理」>「服務帳號」</b>，點擊<b>「建立服務帳號」</b>。名稱任意（例：ga-reader），無需授予角色。',
        ga_help_step2_4: '開啟建立的服務帳號，在<b>「金鑰」分頁 >「新增金鑰」>「建立新金鑰」</b>中選擇 <b>JSON</b> 並下載。',
        ga_help_step2_5: '請將下載的 JSON 檔案透過下方的表單上傳。',

        // Step 3: GA Access
        ga_help_step3_title: "STEP 3: 授予服務帳號 GA 檢視權限",
        ga_help_step3_1: '開啟 <a href="https://analytics.google.com/" target="_blank">Google Analytics</a> 的<b>管理</b>（齒輪圖示）。',
        ga_help_step3_2: '開啟「資源存取管理」，點擊右上角的 <b>「+」按鈕</b>。',
        ga_help_step3_3: "輸入 STEP 2 建立的服務帳號電子郵件地址（例：<code>ga-reader{'@'}your-project.iam.gserviceaccount.com</code>）。<br>※ 電子郵件地址記載在下載的 JSON 檔案中的 <code>client_email</code>。",
        ga_help_step3_4: '角色請選擇<b>「檢視者」</b>後新增。',

        ga_property_id_hint: "Google Analytics 4 管理畫面 > 資源設定 > 資源詳細資料中顯示的數字。",
        ga_service_account_key: "GA 服務帳號金鑰（JSON 檔案）",
        ga_key_uploaded: "服務帳號金鑰已上傳",
        ga_key_description: "請上傳 STEP 2 下載的服務帳號金鑰 JSON 檔案。",
        ga_save: "儲存 GA 設定",
        ga_test_connection: "連線測試",
        ga_test_sample: "取得範例",

        // Media Analysis
        ga_analysis_title: "自家媒體分析",
        ga_analysis_description: "根據 Google Analytics 資料，以 AI 分析自家媒體的熱門文章趨勢。分析結果將用於新文章的匹配度自動判定。",
        ga_analyze_button: "分析熱門文章",
        ga_analyzing: "分析中...",
        ga_last_analyzed: "最後分析時間",
        ga_analysis_result_label: "分析結果（熱門文章趨勢・施策提案）",
        ga_match_prompt_label: "匹配度判定提示詞",
        ga_match_prompt_hint: "此提示詞用於判定新文章的匹配度。可透過GA分析自動生成，也可手動直接編輯。",
        ga_match_prompt_placeholder: "例: 以下文章是否符合我們媒體的目標讀者？請根據內容、語調和主題判定，符合回傳true，不符合回傳false。",
        ga_match_prompt_save: "儲存提示詞",
        ga_save_success: "GA 設定已儲存。",
        ga_save_failed: "GA 設定儲存失敗。",
        ga_match_prompt_save_success: "已儲存。",
        ga_match_prompt_save_failed: "儲存失敗。",
        ga_test_failed: "連線測試失敗。",
    },

    // fw05_Articles.vue
    Articles: {
        layout_title: "清單標題",

        nav_group_content: "內容管理",
        nav_group_collection: "文章收集",
        nav_group_generation: "文章生成設定",
        nav_group_settings: "設定・連結",

        articles: "生成文章列表",
        futured_media: "精選圖片",
        ai_generation: "AI生成",
        category: "類別",
        sample_article: "樣本文章",
        prompt_template: "提示",
        css_selector: "CSS 選擇器",
        css_selector_name: "CSS 選擇器名稱",
        css_selector_new: "新增 CSS 選擇器",
        css_selector_edit: "編輯 CSS 選擇器",
        domain_pattern: "網域模式",
        domain_pattern_placeholder: "例如: bbc.com",
        path_pattern: "路徑模式",
        path_pattern_placeholder: "例如: /news/ 或 .* (預設)",
        selectors_json_array: "選擇器 (JSON 陣列)",
        selectors_placeholder: '例如: ["#main-content", "article"]',
        priority: "優先級",
        priority_hint: "數字越小優先級越高",
        connect_to: "投稿目標",
        none: "無",
        dashboard: "儀表板",
        crawl_sites: "取得網站",
        crawl_articles: "最新文章列表",
        article_list_setting: "清單設定",

        search_keyword: "關鍵詞",
        filter: "過濾",

        article_generate_status: "生成狀態",
        article_generate_status_0: "不支援",
        article_generate_status_1: "生成中",
        article_generate_status_2: "完成",
        article_generate_status_3: "錯誤",

        cms_post_status: "提交狀態",
        cms_post_status_0: "不支援",
        cms_post_status_1: "發布中",
        cms_post_status_2: "完成",
        cms_post_status_3: "錯誤",

        create: "新建",
        post: "發布",
        refresh: "更新列表",

        select_all: "全選/取消全選",

        selected: "選擇",

        generate_type: "文章產生類型",
        generate_type_3: "從原始來源生成（從 URL）",
        generate_type_4: "從原始來源生成（包含圖片轉載）",
        generate_type_5: "從音訊資料生成",
        generate_type_6: "從主題生成",
        agent_instruction: "AI指令",
        agent_instruction_placeholder: "請以自然語言輸入文章主題或需求，AI將自動進行網路搜尋，收集參考資料並生成文章。",
        keyword: "關鍵詞",
        urls: "來源網址 / 文字",
        audio_file: "音訊檔案",
        audio_select: "選擇檔案",
        audio_hint: "支援格式: mp3, mp4, wav, m4a, ogg, flac 等",
        audio_supplement: "補充資訊（選填）",
        audio_supplement_placeholder: "例: 主題「AI應用案例」、說話者: 田中（採訪者）、山田（專家）",
        audio_no_file: "未設定音訊檔案",
        inline_images: "文章內圖片",
        inline_images_select: "選擇圖片",
        inline_images_hint: "上傳要放置在文章中的圖片（最多10張）。系統會分析圖片內容，自動放置在文章適當位置。",
        subtitles: "子標題",
        sample_article_name: "參考文章",
        prompt_template_name: "提示模板",
        additional_prompt: "追加提示",
        additional_prompt_placeholder: "輸入對提示模板的追加指示（選填）",
        category_name: "類別",
        ai_model: "AI模型",
        image_generation_mode: "圖片生成模式",
        image_generation_mode_off: "關閉",
        image_generation_mode_on: "開啟",
        select_image_style: "選擇圖片風格",
        image_style_realistic: "寫實",
        image_style_anime: "動漫",
        image_style_illustration: "插畫",
        image_style_photography: "攝影",

        article_title: "標題",
        posted_url: "發布目的地連結",
        created_at: "生成時間",
        modified_at: "更新時間",

        edit: "編輯",
        delete: "刪除",
        delete_prompt: "文章：您要刪除 title 嗎？",

        OK: "確定",
        cancel: "取消",

        regenerate: "新產生",

        check_modal_msg: " 是必填欄位, 請輸入。",
        connection_required: "未設定連接目標。請在發布前設定連接目標。",
        
        enable: "啟用",
        update: "更新",
        append_2: "新增",
    },

    // fw37_dashboard.vue
    dashboard: {
        article_stats_title: "文章統計",
        total_articles: "文章合計",
        generate_status: "文章生成狀態",
        cms_post_status: "文章投稿狀態",
        analysis_language_label: "分析結果語言",
        analysis_language_ja: "日文",
        analysis_language_tw: "繁體中文",
        analysis_language_en: "英文",
        status_not_started: "未處理",
        status_in_progress_gen: "生成中",
        status_completed: "完成",
        status_error: "錯誤",
        status_in_progress_post: "發布中",
        media_analysis_title: "自家媒體分析",
        recent_articles_title: "最新文章摘要",
        recent_articles_empty: "尚無最新文章",
        crawl_sites_title: "取得網站狀態",
        crawl_sites_empty: "尚未註冊取得網站",
        site_name: "網站名稱",
        last_crawled: "最後取得時間",
        active: "有效",
        inactive: "無效",
        not_crawled_yet: "尚未取得",
        match_score: "匹配度",
        article_title: "文章標題",
        source_site: "來源網站",
        crawled_at: "取得時間",
        active_sites: "有效網站",
        total_sites: "全部網站",
        status_label: "狀態",
        ga_analysis_success: "分析已完成。",
        ga_analysis_failed: "分析失敗。",
    },

    // fw10_Articles_Edit.vue
    Articles_Edit: {
        h4: "生成條件",

        keyword: "關鍵詞",
        subtitles: "子標題",
        urls: "來源網址 / 文字",
        urls_placeholder: "https://example.com\n或直接貼上來源文字",
        urls_hint: "可輸入URL或文字。輸入URL時將自動取得頁面內容。",
        sample_article_name: "參考文章",
        prompt_template_name: "提示模板",
        additional_prompt: "追加提示",
        additional_prompt_placeholder: "輸入對提示模板的追加指示（選填）",
        agent_instruction: "AI指令",
        agent_instruction_placeholder: "請以自然語言輸入文章主題或需求，AI將自動進行網路搜尋，收集參考資料並生成文章。",
        generate_type: "文章產生類型",
        ai_model: "AI模型",
        image_generation_mode: "圖片生成模式",
        image_generation_mode_off: "關閉",
        image_generation_mode_on: "開啟",
        select_image_style: "選擇圖片風格",
        image_style_realistic: "寫實",
        image_style_anime: "動漫",
        image_style_illustration: "插畫",
        image_style_photography: "攝影",
        regenerate: "新產生",
        publish: "發布草稿",
        return: "返回",
        return_to_list: "返回",
        update: "更新",

        generate_result: "生成結果",

        posted_url: "文章連結",
        slug: "永久連結",

        article_title: "文章標題",
        futured_media: "精選圖片",
        connection: "發布目標",
        content: "內容",
        tags: "標籤",

        // 一次來源判定
        primary_source_check: "一次來源判定",
        primary_source_checking: "判定中...",
        primary_source_yes: "一次來源",
        primary_source_no: "二次來源",
        primary_source_unknown: "無法判定",
        primary_source_confidence: "信心度",
        primary_source_no_urls: "請先輸入URL再進行判定",
        primary_source_error: "一次來源判定時發生錯誤",
    },

    // fw11_futured_medias.vue
    Futured_medias: {
        title: "精選圖片",

        search_keyword: "關鍵詞",
        filter: "過濾",

        append: "新增",
        delete_much: "大量刪除",
        refresh: "更新列表",

        select_all: "全選/取消全選",
        selected: "選擇",
        author: "建立時間",
        operation: "操作",

        image_upload: "圖片上傳",
        image_edit: "編輯",

        drag_image: "拖曳圖片",
        or: "或者",
        select_file: "點擊選擇檔案",

        image: "圖像",
        file_name: "檔案名稱",

        content: "内容",
        append_2: "新增",
        return: "返回",

        edit_category: "編輯類別",
        update: "更新",

        OK: "確定",
        cancel: "取消",

        edit: "編輯",
        delete: "刪除",

        delete_prompt: "提示範本：確定要刪除 name 嗎？",
        delete_prompt_much: "提示範本：確定要刪除 num 筆資料嗎？",

        png_alert: "請拖曳/選擇一個 PNG 文件",
        feature_disabled: "此功能未開放",
    },

    // fw14_categories.vue
    Categories: {
        category: "類別",

        search_keyword: "關鍵詞",
        filter: "過濾",

        append: "新增",
        delete_much: "大量刪除",
        refresh: "更新列表",

        select_all: "全選/取消全選",
        selected: "選擇",
        category_name: "類別名稱",
        author: "建立時間",
        operation: "操作",

        new_category: "新增類別",
        append_2: "新增",
        return: "返回",

        edit_category: "編輯類別",
        update: "更新",

        OK: "確定",
        cancel: "取消",

        edit: "編輯",
        delete: "刪除",

        delete_prompt: "類別：確定要刪除 name 嗎？",
        delete_prompt_much: "類別：確定要刪除 num 筆資料嗎？",
    },

    // fw17_sample_articles.vue
    Sample_articles: {
        title: "樣本文章",

        search_keyword: "關鍵詞",
        filter: "過濾",

        append: "新增",
        delete_much: "大量刪除",
        refresh: "更新列表",

        select_all: "全選/取消全選",
        selected: "選擇",
        sample_articles: "樣本文章",
        author: "建立時間",
        operation: "操作",

        new_sample_article: "新增樣本文章",
        edit_sample_article: "編輯樣本文章",

        sample_article_name: "樣本文章名稱",
        default: "預設",
        content: "内容",
        append_2: "新增",
        return: "返回",

        edit_category: "編輯類別",
        update: "更新",

        OK: "確定",
        cancel: "取消",

        edit: "編輯",
        delete: "刪除",

        delete_prompt: "類別：確定要刪除 name 嗎？",
        delete_prompt_much: "類別：確定要刪除 num 筆資料嗎？",

        extract_from_url: "從URL提取正文",
        extract_button: "提取",
        extracting: "提取中...",
        extract_no_url: "請輸入URL",
        extract_error: "正文提取失敗",
    },

    // fw20_prompt_templates.vue
    prompt_templates: {
        title: "提示模板",

        new_prompt_templates: "新增提示模板",
        edit_prompt_templates: "編輯提示模板",

        search_keyword: "關鍵詞",
        filter: "過濾",

        append: "新增",
        delete_much: "大量刪除",
        refresh: "更新列表",

        select_all: "全選/取消全選",
        selected: "選擇",
        author: "建立時間",
        operation: "操作",

        prompt_template_name: "提示模板名稱",
        default: "預設",
        content: "内容",
        append_2: "新增",
        return: "返回",

        // edit_category: "編輯類別",
        update: "更新",

        OK: "確定",
        cancel: "取消",

        edit: "編輯",
        delete: "刪除",

        delete_prompt: "提示範本：確定要刪除 name 嗎？",
        delete_prompt_much: "提示範本：確定要刪除 num 筆資料嗎？",
    },

    // fw24_connections.vue
    connections: {
        title: "連接",

        new_connection: "新增連接",
        edit_connection: "編輯連接",

        search_keyword: "關鍵詞",
        filter: "過濾",

        append: "新增",
        delete_much: "大量刪除",
        refresh: "更新列表",

        select_all: "全選/取消全選",
        selected: "選擇",
        author: "建立時間",
        operation: "操作",

        connection_name: "連接名稱",
        authentication_type: "認證類型",
        domain_url: "基本網址",
        username: "使用者身分",
        password: "密碼",
        application_password: "應用程式密碼",

        default: "預設",
        append_2: "新增",
        return: "返回",

        update: "更新",

        OK: "確定",
        cancel: "取消",

        edit: "編輯",
        delete: "刪除",
        enable: "啟用",

        delete_prompt: "提示範本：確定要刪除 name 嗎？",
        delete_prompt_much: "提示範本：確定要刪除 num 筆資料嗎？",
    },

    // fw34_usage.vue
    usage: {
        Trial: "試用",
        Standard: "標準",

        use_trial_plan_now: "目前正在使用試用計劃",
        register_standard_plan: "註冊標準計劃",

        plan: "合約計劃",
        plan_name: "計劃名稱",
        plan_monthly_price: "基本費用",
        include_base_points: "點可用",
        point_limit: "上限點數",
        point_price: "超額每點費用",
        points: "點",

        usage: "使用狀況",
        total_points: "總消費點數",

        charge: "計費金額",
        over_billing: "超額費用",
        points_number: "點數",
        billing_amount: "費用總計",
        cancel_success: "方案已取消，仍可使用到月底。",
        already_cancelled: "此方案已取消。",
        cancel_error: "取消方案時發生錯誤。",
        plan_modal_title: "申請標準方案",
        plan_basic_info: "◾️基本資訊",
        plan_name_label: "方案名稱",
        standard_plan_name: "標準方案",
        monthly_fee_label: "月費",
        monthly_fee_value: "35,000 日圓（未稅）起",
        points_granted_label: "每月點數",
        points_granted_value: "600 點／月",
        extra_fee_label: "超額費用",
        extra_fee_value: "每 1 點 50 日圓（未稅）",
        contract_billing_info: "◾️合約與請款資訊",
        contract_period_label: "合約期間",
        contract_period_value: "按月計費（自動續約）",
        proration_label: "首月按比例計費",
        proration_value: "自簽約日起按比例計費",
        payment_method_label: "付款方式",
        payment_method_value: "信用卡（Stripe）",
        billing_timing_label: "請款時點",
        billing_timing_value: "每月 1 日（或依註冊日而定）",
        cancel_policy_label: "取消／解約",
        cancel_policy_value: "可於下次更新日前一天前取消",
        usage_points_info: "◾️使用內容與點數機制",
        points_usage_target_label: "點數適用範圍：",
        points_usage_target_value: "文章生成、標題生成、摘要等各類 AI 功能",
        points_rules_label: "點數消耗規則：",
        points_range_1: "1～2,000 字：",
        points_cost_1: "1 點",
        points_range_2: "2,001～4,000 字：",
        points_cost_2: "2 點",
        points_range_3: "4,001～6,000 字：",
        points_cost_3: "3 點",
        points_range_4: "6,001 字以上：",
        points_cost_4: "4 點",
        points_rollover: "點數不會結轉，每月重置",
        points_check_method: "可在我的頁面查看剩餘點數",
        notice_1_line_1: "※ 付款頁面會由 Stripe 安全處理。",
        notice_1_line_2: "本站不會儲存您的信用卡資訊。",
        notice_2_line_1: "※ 註冊完成後，方案會立即生效。",
        notice_2_line_2: "剩餘點數可於我的頁面查看。",
        cancel_button: "取消",
        register_standard_plan_cta: "註冊信用卡並申請標準方案",
        cancel_modal_title: "確認取消方案",
        cancel_about_title: "關於取消",
        cancel_rule_1: "取消後仍可使用到下次更新日（月末）",
        cancel_rule_2: "若於更新日前取消，不提供按比例退款",
        cancel_rule_3: "可隨時重新申請",
        warning_title: "注意事項",
        cancel_warning_text: "執行取消後，從下個月起將停止收取標準方案費用。",
        execute_cancel: "執行取消",
        proration_badge: "（按比例：{percent}%，{active_days}/{period_days} 天）",
        cancel_plan_button: "取消方案",
        cancelled_status: "已取消",
        cancelled_date: "取消日期",
        cancelled_notice: "仍可使用到月底。",
    },

    HomeView: {
        login_now: "立即登入",
        enter_workspace: "進入工作台",
        login_hint: "免信用卡即可開始使用",
        feature_vector_search: "向量搜索",
        feature_ai_chat: "AI 對話",
        feature_smart_writing: "智能寫作",
    },

    options_error_2: {
        h1              : "無訪問權限",
        error_message   : "沒有 For Writing 的訪問許可權。",
        back_button     : "返回"
    },

    // fw35_crawl_sites.vue
    Crawl_sites: {
        title: "自動取得網站",
        modal_new_title: "新增自動取得網站",
        modal_edit_title: "編輯自動取得網站",
        site_name_label: "自動取得網站名稱：",
        site_name_placeholder: "媒體名稱",
        news_page_url_label: "最新文章列表頁 URL：",
        match_threshold_label: "匹配度門檻（%）：",
        match_threshold_hint: "※匹配度判定提示詞會由清單設定中的 GA 連動自動生成",
        generation_settings_title: "自動新增時的文章生成設定",
        generate_type: "生成類型",
        ai_model: "AI 模型",
        sample_article: "參考文章",
        prompt_template: "提示模板",
        connection: "投稿目標",
        select_placeholder: "-- 請選擇 --",
        required: "必填",
        not_set: "未設定",
        add: "新增",
        update: "更新",
        back: "返回",
        cancel: "取消",
        active: "啟用",
        keyword: "關鍵字：",
        filter: "篩選",
        new_item: "新增",
        refresh: "更新列表",
        select_all: "全選/取消全選",
        target: "對象",
        site_name: "網站名稱",
        created_at: "建立日期",
        operation: "操作",
        edit: "編輯",
        crawl: "爬取",
        delete: "刪除",
        required_settings_alert: "以下文章生成設定為必填：",
        create_failed: "建立失敗",
        update_failed: "更新失敗",
        delete_failed: "刪除失敗",
        crawl_started: "已開始爬取，請到最新文章列表確認結果。",
        crawl_failed: "執行爬取失敗",
        delete_confirm: "確定要刪除「{site_name}」嗎？相關最新文章也會一併刪除。",
        auto_add_settings: "自動新增設定",
        auto_add_enabled: "自動將符合門檻的新文章加入文章清單",
        auto_generate_enabled: "新增後立即執行文章生成",
        save_settings: "儲存設定",
        saving: "儲存中...",
        auto_add_desc: "爬取完成後，符合門檻（is_approved=true）的文章將自動新增。門檻值可在各站點設定中變更。",
    },
    Crawl_articles: {
        title: "最新文章列表",
        modal_edit_title: "編輯最新文章",
        title_label: "標題：",
        url_label: "文章 URL：",
        match_score_label: "匹配度（AI 判定）：",
        match_reason_label: "判定理由（AI 判定）：",
        not_judged: "未判定",
        update: "更新",
        add_to_articles: "加入文章列表",
        dismiss: "駁回",
        delete: "刪除",
        back: "返回",
        cancel: "取消",
        keyword: "關鍵字：",
        source_site_filter: "來源網站：",
        bulk_dismiss: "批次駁回",
        bulk_delete: "批次刪除",
        refresh: "更新列表",
        select_all: "全選/取消全選",
        target: "對象",
        site_name: "網站名稱",
        article_title: "標題",
        url: "URL",
        created_at: "建立日期",
        match_score: "匹配度",
        status: "狀態",
        operation: "操作",
        edit: "編輯",
        page_size: "顯示筆數：",
        page_size_option: "{n} 筆",
        total_count: "{count} 筆",
        status_new: "未處理",
        status_added: "已加入",
        status_dismissed: "已駁回",
        status_all: "全部",
        select_article: "請選擇文章",
        bulk_add_success: "已將 {count} 篇文章加入文章列表",
        add_success: "已加入文章列表",
        add_failed: "加入文章失敗",
        update_failed: "更新失敗",
        delete_failed: "刪除失敗",
        dismiss_failed: "駁回失敗",
        refresh_failed: "更新失敗",
        delete_confirm: "確定要刪除「{title}」嗎？",
        bulk_delete_confirm: "確定要刪除 {count} 篇文章嗎？",
    },
}
export default tw;